
export default class Utils {
    deepCopy (obj: object): any{
        return obj && JSON.parse(JSON.stringify(obj));
    }   
    replaceLastPartOfPath(filePath : string, newFileName : string) : string {
        const lastSlashIndex = filePath.lastIndexOf('/');
        if (lastSlashIndex === -1) {
            throw new Error('Invalid file path format');
        }
        return filePath.substring(0, lastSlashIndex + 1) + newFileName;
    }
}
